import { Theme, css } from '@emotion/react';

export const widgetFormRoot = ({ spacing }: Theme) => css`
  & > * {
    margin-top: ${spacing(1)}px;
    margin-bottom: ${spacing(1)}px;
  }
`;

export const widgetFormButtonContainer = ({ spacing }: Theme) => css`
  display: flex;
  gap: ${spacing(1.5)}px;
  margin-top: ${spacing(1)}px;
  margin-bottom: ${spacing(1)}px;
`;

export const widgetTypeSelect = ({ spacing }: Theme) => css`
  margin-left: ${spacing(0.5)}px;
  margin-top: ${spacing(1)}px;
  margin-bottom: ${spacing(1.5)}px;
`;
